import { createRoute } from 'framework/routing';

const APPLICATIONS_PATH = '/candidates-applications';

export const useApplicationsRoute = () => createRoute({ listRoute: APPLICATIONS_PATH });

export const applicationsRouterPath = () => `${APPLICATIONS_PATH}/*`;
